import React from 'react';
import { Modal } from 'syngenta-digital-cropwise-react-ui-kit';

import InfoIcon from 'assets/info.svg?react';
import LayoutStrings from 'screens/Applications&WorkOrders/StepsLayout/Constants/layoutStrings';

interface ShowNoCropZonesModalProps {
  isApplication?: boolean;
}

const showNoCropZonesModal = ({
  isApplication = true
}: ShowNoCropZonesModalProps = {}) => {
  const entityTypeWithArticle = isApplication
    ? 'an Application'
    : 'a Work Order';
  const content = LayoutStrings.modal.noCropZonesContent.replace(
    '{entityType}',
    entityTypeWithArticle
  );

  Modal.warning({
    icon: (
      <span className="flex items-center" style={{ gap: 12 }}>
        <span className="flex items-center">
          <InfoIcon width={24} height={24} />
        </span>
        <span
          className="font-semibold"
          style={{ fontSize: 16, color: '#14151C' }}
        >
          {LayoutStrings.modal.noCropZonesTitle}
        </span>
      </span>
    ),
    content: (
      <div className="flex items-start" style={{ paddingRight: 24 }}>
        <span className="inline-block" style={{ width: 36, minWidth: 36 }} />
        <span
          className="text-sm font-normal not-italic wrap-break-word text-left mt-0"
          style={{ width: 335 }}
        >
          {content}
        </span>
      </div>
    ),
    okText: 'Dismiss',
    centered: true,
    closable: false,
    maskClosable: false,
    transitionName: '',
    maskTransitionName: '',
    width: 423,
    bodyStyle: {
      padding: 24
    },
    okButtonProps: {
      style: {
        background: '#FFF',
        color: '#14151C',
        padding: '10px 16px',
        borderRadius: 4,
        fontSize: 14,
        fontWeight: 400,
        border: '1px solid #C2C7D0'
      }
    }
  });
};

export default showNoCropZonesModal;
